(() => {
  const kits = {carpet:'carpet-upholstery-care',microfiber:'microfiber-towels-accessories',interior:'interior-detailing',glass:'glass-cleaning-care'};
  const init = () => {
    const params = new URLSearchParams(location.search);
    const kit = params.get('pt_kit');
    const nav = document.querySelector('[data-pt-kit-back]');
    if (nav && Object.prototype.hasOwnProperty.call(kits, kit)) {
      const url = new URL('/collections/' + kits[kit], location.origin);
      url.hash='pt-featured-kit';
      nav.querySelector('[data-pt-kit-back-link]').href = url.pathname + url.search + url.hash;
      nav.hidden = false;
      const note = nav.querySelector('[data-pt-kit-draft-note]');
      if (note) note.hidden = !document.querySelector('main[data-template="404"]');
    }
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
(() => {
  let opener = null;
  let openedFromKit = false;
  let openedFromProducts = false;
  const currentPanel = () => {
    const id = location.hash.slice(1);
    if (!/^pt-kit-details-\d+$/.test(id)) return null;
    const panel = document.getElementById(id);
    return panel && panel.matches('[data-pt-kit-detail]') ? panel : null;
  };
  const hiTechSource = () => new URLSearchParams(location.search).get('pt_source') === 'hi-tech';
  const hiTechReturn = () => {
    const url = new URL('/',location.origin);
    url.hash='hi-tech';
    location.assign(url.pathname+url.search+url.hash);
  };
  const sync = () => {
    const panel = currentPanel();
    if (panel) {
      panel.querySelectorAll('[data-pt-preview-back]').forEach(link => {
        if (!link.dataset.ptOriginalText) { link.dataset.ptOriginalText = link.textContent; link.dataset.ptOriginalHref = link.getAttribute('href'); }
        link.textContent = openedFromProducts ? '← Back to Products' : link.dataset.ptOriginalText;
        link.setAttribute('href', openedFromProducts ? '#ResultsList' : link.dataset.ptOriginalHref);
      });
      panel.querySelectorAll('img').forEach((image, index) => { image.loading = 'eager'; if (index === 0) image.fetchPriority = 'high'; });
      const title = panel.querySelector('h2');
      if (title) title.focus({preventScroll:true});
      panel.scrollIntoView({block:'start',behavior:'instant'});
    } else if (opener && opener.isConnected) {
      opener.focus({preventScroll:false});
      opener = null;
      openedFromKit = false;
      openedFromProducts = false;
    }
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a');
    if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    if (/^#pt-kit-details-\d+$/.test((link.getAttribute('href') || '').trim())) {
      opener = link;
      openedFromProducts = !!link.closest('.pt-shopping__card');
      openedFromKit = !openedFromProducts;
    }
    if (link.matches('[data-pt-preview-back]') && currentPanel() && openedFromProducts) {
      const products = document.getElementById('ResultsList');
      if (products instanceof HTMLDetailsElement) products.open = true;
    }
    if (link.matches('[data-pt-preview-back]') && currentPanel() && hiTechSource()) {
      event.preventDefault();
      hiTechReturn();
      return;
    }
    if (link.matches('[data-pt-preview-back]') && currentPanel() && openedFromKit) {
      event.preventDefault();
      location.hash = link.hash || 'pt-featured-kit';
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !currentPanel()) return;
    event.preventDefault();
    if (hiTechSource()) hiTechReturn(); else location.hash = openedFromProducts ? 'ResultsList' : 'pt-featured-kit';
  });
  window.addEventListener('hashchange',sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',sync);else sync();
})();
